import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { ProductsService, JournalService } from '@vestiaire/api-sdk-angular';
import { IsLoggedGuard } from '@app/shared/guards';
import { Logger } from '@app/core/logging';
import { PriceDropService } from '@app/shared/services/price-drop/priceDrop.service';

@Component({
  selector: 'vc-discussions-form',
  templateUrl: './discussions-form.component.html',
  styleUrls: ['./discussions-form.component.scss']
})
export class DiscussionsFormComponent implements OnInit {
  @Input()
  isAuthenticated: boolean;

  @Input()
  userInfo: any;

  // The product or edito ID in mariaDB
  @Input()
  idItem: string;

  @Input()
  commentType: string;

  @Input()
  isModalView = false;

  @ViewChild('commentMsg', { read: ElementRef, static: false })
  commentMsgInput: ElementRef;

  @ViewChild('commentForm', { read: ElementRef, static: false })
  formContainer: ElementRef;

  @ViewChild('wrapper', { read: ElementRef, static: false })
  wrapper: ElementRef;

  @Output()
  send: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  public imgixPath = environment.imgixPath;
  public lastMsg = '';
  public loader = false;
  private timeout = null;

  constructor(
    private loggedGuard: IsLoggedGuard,
    private journalService: JournalService,
    private productsService: ProductsService,
    private priceDropService: PriceDropService,
    private logger: Logger
  ) {}

  ngOnInit() {}

  onFocus() {
    if (!this.isAuthenticated) {
      this.commentMsgInput.nativeElement.blur();
    }
    this.loggedGuard.isLoggedIn();
  }

  onSubmit(msg) {
    switch (this.commentType) {
      case 'product':
        if (this.idItem !== null && typeof this.idItem !== 'undefined') {
          this.loader = true;
          this.priceDropService.addPriceDropToLocalForage(this.idItem);
          this.productsService.createProductComment(this.idItem, { text: msg }).subscribe(
            res => {
              if (res.data) {
                this.send.emit(res.data);
                this.commentMsgInput.nativeElement.value = '';
                this.loader = false;
              }
            },
            error => {
              this.logger.error("Can't create new product comment:", error);
              this.loader = false;
            }
          );
        }
        break;
      case 'edito':
        if (this.idItem) {
          this.loader = true;
          this.journalService.createEditoComment(this.idItem, { text: msg }).subscribe(
            res => {
              if (res.data) {
                this.send.emit(res.data);
                this.commentMsgInput.nativeElement.value = '';
                this.loader = false;
              }
            },
            error => {
              this.logger.error("Can't create new edito comment:", error);
              this.loader = false;
            }
          );
        }
        break;
    }
  }

  resizeInput() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.commentMsgInput.nativeElement.style.height = 'auto';
      this.commentMsgInput.nativeElement.style.height = this.commentMsgInput.nativeElement.scrollHeight + 3 + 'px';
      this.change.emit(this.wrapper.nativeElement.clientHeight);
    }, 500);
  }
}
